import { EventEmitter } from '@meitu/saas-editor-core/es/framework';

export * from './events-name';

export const events = new EventEmitter();
